import routeHandler from './routes';
import MODULE_ID from './moduleId';

const module = {
    moduleType: 'Begleitfahrt',
    api: 'begleitfahrt',
    path: 'begleitfahrt',
    moduleId: MODULE_ID,
    routeHandler,
};

export default module;